import React from 'react';
import { IonIcon } from '@ionic/react';
import { checkmarkCircleOutline, timeOutline } from 'ionicons/icons';

export function etapasDoPedido(pedido: any) {
  const etapas: { nome: string; indice: string }[] = Array.isArray(pedido.configWorkflow)
    ? pedido.configWorkflow.flatMap((etapa: any, posicao: number) => typeof etapa?.status === 'string' && etapa.status.trim()
      ? [{ nome: etapa.status, indice: String(etapa.indice ?? posicao) }] : []) : [];
  const status = typeof pedido.statusWorkflow === 'string' ? pedido.statusWorkflow.trim() : '';
  const indice = pedido.indiceWorkflow == null ? null : String(pedido.indiceWorkflow);
  const candidatos = etapas.map((etapa, posicao) => ({ ...etapa, posicao }))
    .filter(etapa => etapa.indice === indice && (!status || etapa.nome.trim() === status));
  const correspondentes = etapas.map((etapa, posicao) => ({ ...etapa, posicao }))
    .filter(etapa => etapa.nome.trim() === status);
  const atual = candidatos.length === 1 ? candidatos[0].posicao : correspondentes.length === 1 ? correspondentes[0].posicao : -1;
  return { etapas, atual, status: status || etapas[atual]?.nome || 'Etapa não informada' };
}

export function dataAtualizacaoPedido(value: any): string | null {
  if (value == null || value === '' || (typeof value !== 'string' && typeof value !== 'number')) return null;
  const data = new Date(value);
  return Number.isNaN(data.getTime()) ? null : data.toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
  });
}

const PedidoAcompanhamento: React.FC<{ pedido: any }> = ({ pedido }) => {
  const { etapas, atual, status } = etapasDoPedido(pedido);
  const atualizacao = dataAtualizacaoPedido(pedido.dataAlteracao);
  // This only styles the explicit delivery label; order status and action permissions remain separate.
  const entregue = status.trim().toLocaleLowerCase('pt-BR') === 'entregue';
  return <section className="pedido-acompanhamento" aria-label="Acompanhamento do pedido">
    <div className={`pedido-etapa-atual${entregue ? ' pedido-etapa-entregue' : ''}`}>
      <IonIcon icon={entregue ? checkmarkCircleOutline : timeOutline} aria-hidden="true" />
      <div><p>Etapa atual do pedido</p><h2>{status}</h2></div>
    </div>
    {etapas.length > 0 && <ol className="pedido-progresso" style={{ gridTemplateColumns: `repeat(${Math.min(etapas.length, 4)}, minmax(0, 1fr))` }} aria-label="Etapas do workflow">
      {etapas.map((etapa, posicao) => <li key={`${etapa.indice}-${posicao}`} aria-current={posicao === atual ? 'step' : undefined} className={atual >= 0 && posicao <= atual ? 'pedido-etapa-alcancada' : undefined}>
        <span className="pedido-etapa-traco" aria-hidden="true" /><span>{etapa.nome}</span>
      </li>)}
    </ol>}
    {atualizacao && <p className="pedido-atualizado">Última atualização do pedido: <time dateTime={new Date(pedido.dataAlteracao).toISOString()}>{atualizacao}</time></p>}
  </section>;
};
export default PedidoAcompanhamento;
